var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 230,
    viewBox: "0 0 230 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M206.182 148.909V171.818H57.2727V160.364H45.8182V114.545H34.3636V80.1818H22.9091V22.9091H0V0H45.8182V34.3636H229.091V80.1818H217.636V114.545H206.182V126H68.7273V148.909H206.182ZM45.8182 68.7273H57.2727V103.091H194.727V68.7273H206.182V57.2727H45.8182V68.7273ZM68.7273 183.273H91.6364V194.727H103.091V217.636H91.6364V229.091H68.7273V217.636H57.2727V194.727H68.7273V183.273ZM160.364 183.273H183.273V194.727H194.727V217.636H183.273V229.091H160.364V217.636H148.909V194.727H160.364V183.273Z",
    fill: "#ddd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.2f6bd89dd3ee6608bae3257884446508.svg";
export { ForwardRef as ReactComponent };